import { useMutation, useQueryClient } from '@tanstack/react-query';
import { cifStampService } from '@/services/cifStampService';
import { queryKeys } from '@/lib/queryKeys';

export const useUploadCifStamp = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ stampBase64, filename }: { stampBase64: string; filename: string }) =>
      cifStampService.upload(stampBase64, filename),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.cifStamp.detail });
    },
  });
};

export const useDeleteCifStamp = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => cifStampService.remove(),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.cifStamp.detail });
    },
  });
};
